import { MotifButton, MotifCheckbox, MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import React, { useCallback, useState } from 'react';

import iconSvg from '../../assets/icons/icon.svg.json';
import { useSelector } from 'react-redux';

export const CellTooltip = (props: any) => {
  const { text, score } = props;
  const isTextTruncated = text?.length > 100;

  return (
    <div className="max-w-[40rem]">
      <span className="line-clamp-3">{text}</span>
      {isTextTruncated && (
        <MotifTooltip
          hideArrow={false}
          allowHover={true}
          allowClick={false}
          flip={true}
          placement={'right'}
          trigger={
            <span
              className="!font-bold cursor-pointer hover:underline"
            >
              Read more
            </span>
          }
        >
          <div className='max-w-80'>
            <span className="block">{text}</span>
          </div>
        </MotifTooltip>
      )}
    </div>
  );
};

const OptionsCell = (props: any) => {
  const { Top_1, Top_2, Top_3, selected, onChange, enabledRecommendedOptions } = props;

  const random = Math.random();

  const renderEnabledOptions = useCallback(() => {
    return (
      <>
        {enabledRecommendedOptions?.map((opt, index) => {
          let text = '';
          let score = '';
          if (opt === 'Top_1') {
            text = Top_1?.text;
            score = Top_1?.score;
          }
          if (opt === 'Top_2') {
            text = Top_2?.text;
            score = Top_2?.score;
          }
          if (opt === 'Top_3') {
            text = Top_3?.text;
            score = Top_3?.score;
          }
          return (
            <div
              key={index}
              className={`cursor-default p-4 ${
                index < enabledRecommendedOptions?.length - 1 && 'border-b border-[#A4A3B1]'
              }`}
            >
              <MotifCheckbox
                id={`${random}-checkbox-${index}`}
                checked={selected?.includes(`${index}`)}
                onChange={() => onChange(`${index}`)}
              >
                <CellTooltip text={text} score={score} />
              </MotifCheckbox>
            </div>
          );
        })}
      </>
    );
  }, [enabledRecommendedOptions, selected]);
  return <div className="flex flex-col">{renderEnabledOptions()}</div>;
};

const ViewQuestionsTableRow = (props: any) => {
  const { row, getAiRecommendation, enabledRecommendedOptions } = props;
  const [selectedOptions, setSelectedOptions] = React.useState([] as any);
  const { access } = useSelector((state: any) => state?.user);

  const handleAddBtnClick = () => {
    if (selectedOptions?.length === 0) return alert('Please select atleast one option');
    getAiRecommendation(selectedOptions);
  };
  const onOptionChange = (opt: any) => {
    if (selectedOptions?.includes(opt)) {
      setSelectedOptions(selectedOptions.filter((item: any) => item !== opt));
    } else {
      setSelectedOptions([...selectedOptions, opt]);
    }
  };
  return (
    <tr>
      <td className="border cursor-default p-4 border-[#A4A3B1]">
        <CellTooltip text={row['Requirement']} />
      </td>
      <td className="border cursor-default border-[#A4A3B1]">
        <OptionsCell
          selected={selectedOptions}
          enabledRecommendedOptions={enabledRecommendedOptions}
          onChange={onOptionChange}
          {...row}
        />
      </td>

      <td className="border cursor-default p-4 border-[#A4A3B1] !max-w-[20%]">
        <CellTooltip text={row?.['AI_Recommendations']} />
      </td>

      <td className="border cursor-default p-4 border-[#A4A3B1]">
        {row['Customized'] && <CellTooltip text={row?.['Customized'] ?? ''} />}
        {access.write === true && (
          <span className="bg-gray-800/30  text-center flex justify-center">
            <MotifIcon
              src={iconSvg[row['Customized'] ? 'edit-icon' : 'add-white-icon']}
              onClick={handleAddBtnClick}
              className="cursor-pointer"
              title="add-ico"
            />
            {/* <MotifIcon src={iconSvg[row["Customized"] ? "edit-icon" : "add-icon"]} onClick={handleAddBtnClick} className="cursor-pointer" title='add-ico' /> */}
          </span>
        )}
      </td>
    </tr>
  );
};

export default ViewQuestionsTableRow;
export { OptionsCell };
